import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MigrationLinkComponent } from './migration-link/migration-link.component';
import { MigrationEntryComponent } from './migration-entry/migration-entry.component';
import { MigrationLandingComponent } from './migration-landing/migration-landing.component';


const routes: Routes = [
     {
        path:'',component:MigrationLinkComponent,
        children:[
          {
            path:"migration", component:MigrationEntryComponent
          },  
        ]
      }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentMigrationRoutingModule { }
